import type { IPayScaleQualification } from 'parent-portal/forms/JobRequestTypes';

export function booleanProblem(
    payScaleQualifications: IPayScaleQualification[],
    problemChoiceIds: number[],
): { [key: string]: boolean } {
    const problems = {} as { [key: string]: boolean };

    payScaleQualifications.forEach((qualification: IPayScaleQualification) => {
        if (problemChoiceIds.includes(qualification.qualification_id)) {
            problems[`${qualification.qualification_id}`] = true;
        }
    });

    return problems;
}
